module.exports = __webpack_public_path__ + "img/contract.e3d5f51a.svg";